// extracted by mini-css-extract-plugin
export default {"spinner":"CustomSpinner_spinner__qNANZ","container":"CustomSpinner_container__H1YQg"};